import { render, staticRenderFns } from "./ProjectLogin.vue?vue&type=template&id=b5546e1c&"
import script from "./ProjectLogin.vue?vue&type=script&lang=js&"
export * from "./ProjectLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports